function formatDateTime(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString("nl-NL", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function getWorkOrderLabel(item) {
  const workOrder = item?.workOrderId || {};
  return workOrder.werkbonNummer || workOrder.nummer || "-";
}

function getTechnicianLabel(item) {
  const technician = item?.technicianId || {};
  return technician.name || technician.naam || technician.email || "-";
}

function getLocationLabel(item) {
  const workOrder = item?.workOrderId || {};
  return workOrder?.opdracht?.locatie || workOrder?.locatie || "-";
}

export default function PlannerTimeRequestPanel({
  items,
  loading = false,
  error = "",
  actingId = "",
  onApprove,
  onReject,
  onRefresh,
}) {
  return (
    <section className="bg-white rounded-xl shadow p-5 border-l-4 border-sky-500 md:col-span-2 xl:col-span-3">
      <div className="mb-3 flex items-center justify-between gap-2">
        <div>
          <h3 className="text-lg font-semibold">Extra tijd verzoeken</h3>
          <p className="text-sm text-gray-500">
            Monteurs kunnen extra tijd aanvragen; alleen planners passen de planning aan.
          </p>
        </div>
        <button
          onClick={onRefresh}
          className="text-sm border rounded px-3 py-1 hover:bg-gray-50"
        >
          Vernieuwen
        </button>
      </div>

      {loading ? <p className="text-sm text-gray-500">Laden...</p> : null}
      {error ? <p className="text-sm text-red-600">{error}</p> : null}

      {!loading && !error && items.length === 0 ? (
        <p className="text-sm text-gray-500">Geen open extra tijd verzoeken.</p>
      ) : null}

      {!loading && items.length > 0 ? (
        <div className="space-y-3">
          {items.map((item) => (
            <div
              key={item._id}
              className="rounded-xl border border-gray-200 bg-gray-50/60 p-4"
            >
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div className="space-y-1">
                  <p className="text-sm font-semibold text-gray-900">
                    Monteur {getTechnicianLabel(item)} vraagt +{item.requestedMinutes} minuten
                  </p>
                  <p className="text-sm text-gray-700">
                    Werkbon #{getWorkOrderLabel(item)} • {getLocationLabel(item)}
                  </p>
                  <p className="text-xs text-gray-500">
                    Ingediend op {formatDateTime(item.createdAt)}
                  </p>
                  {item.reason ? (
                    <p className="rounded-lg bg-white px-3 py-2 text-sm text-gray-700">
                      {item.reason}
                    </p>
                  ) : null}
                </div>

                <div className="flex flex-wrap gap-2">
                  <button
                    type="button"
                    onClick={() => onApprove(item)}
                    disabled={actingId === item._id}
                    className="rounded bg-green-600 px-3 py-2 text-sm text-white hover:bg-green-700 disabled:opacity-60"
                  >
                    Goedkeuren
                  </button>
                  <button
                    type="button"
                    onClick={() => onReject(item)}
                    disabled={actingId === item._id}
                    className="rounded border border-red-200 bg-white px-3 py-2 text-sm text-red-700 hover:bg-red-50 disabled:opacity-60"
                  >
                    Afwijzen
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      const workOrderId = item?.workOrderId?._id || item?.workOrderId;
                      if (workOrderId) {
                        window.location.href = `/werkbon/${workOrderId}`;
                      }
                    }}
                    className="rounded border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
                  >
                    Bekijk werkbon
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
}
